import { EtablissementCardDto, TypeDeclaration } from '@common/services';
import { EtablissementDeclarantConsolides } from '@common/ui/etablissement';
import { useMemo } from 'react';

export function useEtablissementsDeclarantsConsolides(pageEtablissementCards) {
  return useMemo<EtablissementDeclarantConsolides[]>(() => {
    const etablissements: EtablissementCardDto[] = pageEtablissementCards?.content ?? [];
    if (!etablissements) return [];

    const etablissementPrincipal = etablissements.find(({ principal }) => principal);

    const etablissementConsolides = etablissements
      .filter(({ principal, typeDeclaration }) => (typeDeclaration === TypeDeclaration.CONSOLIDEE && !principal));

    const etablissementIndividuels = etablissements
      .filter(({ typeDeclaration }) => (typeDeclaration === TypeDeclaration.INDIVIDUELLE));

    return [
      { declarant: etablissementPrincipal, consolides: etablissementConsolides },
      ...etablissementIndividuels.map((etab) => ({ declarant: etab })),
    ];
  }, [pageEtablissementCards]);
}